import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const OrdersPage = loadable(() => withDefaultLoaderModifiers(import("./OrdersPage")));
